function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { Path, Svg } from 'react-native-svg';
import React, { memo } from 'react';
export default /*#__PURE__*/memo(props => {
  return /*#__PURE__*/React.createElement(Svg
  //@ts-ignore
  , _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8h5z",
    fill: "#223044"
  }));
});
//# sourceMappingURL=HomeIcon.js.map